export default __webpack_public_path__ + "static/media/24_nasekomoe.b5b75dbf.JPG";